import React, { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { Route } from '../../../../components/common/Route';
import TimeUnits from '../../../../components/counters/TimeUnits';
import UniversalDrawCounter from '../../../../components/counters/UniversalDrawCounter';
import Purchase from '../../../../components/play/elements/Purchase';
import { RootState } from '../../../../components/play/redux/store';
import { convertAmount } from '../../../../utils/formatters';
import { isThankYouLotto } from '../../../../utils/template';

import Lines from './Lines';

// TODO: add translations
export default function Summary() {
    const isTemplateThankYouLotto = useMemo(() => isThankYouLotto(), []);
    const { currencyCode, lottery, nextDraw, nextNextDraw, price } = useSelector((state: RootState) => state.playStore);

    if (!isTemplateThankYouLotto) {
        return null;
    }

    const counterUnits: TimeUnits = {
        day: 'days',
        hour: 'hours',
        minute: 'minutes',
        second: 'seconds',
    };

    return (
        <>
            <div className="card bg-white bg-opacity-15 text-white checkout-card">
                <div className="card-body">
                    <h4>Checkout</h4>
                    <div>
                        Single ticket price:{' '}
                        <span className="fw-bold">{convertAmount(price.sellAmountGross, currencyCode)}</span>
                    </div>
                    <Lines />

                    <div className="mt-4">
                        <i className="bi bi-clock" /> Draw:
                        <span className="fw-bold ms-1">
                            <UniversalDrawCounter
                                nextDraw={nextDraw}
                                nextNextDraw={nextNextDraw}
                                timeUnits={counterUnits}
                            />
                        </span>
                    </div>

                    <Purchase />
                </div>
            </div>

            <div id="error-box" />
            <div id="info-box" />

            <div className="mt-4">
                <div>Are you already a winner?</div>
                <a
                    href={Route('results', { lottery: lottery.display_slug })}
                    className="fw-bold"
                    style={{ color: '#9d25ff' }}
                >
                    See past results
                </a>
            </div>
        </>
    );
}
